import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgot-component',
  templateUrl: './forgot-component.component.html',
  styleUrls: ['./forgot-component.component.css']
})
export class ForgotComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
